import { map, filter } from 'rxjs/operators';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Appointment } from '../../store/one-time-appointment/appointment.entity';
import { AppointmentService } from '../../providers/appointment.service';
import { AppointmentInfoType } from '../appointment-info/appointment-info';

@Component({
    selector: 'app-history-tab',
    templateUrl: './history-tab.component.html',
    styleUrls: ['./history-tab.component.scss', '../appointment-overview/appointment-overview.component.scss']
})
export class HistoryTabComponent {
    public isInit$: Observable<boolean>;
    public HISTORY_APPOINTMENT_INFO_TYPE = AppointmentInfoType.HISTORY;

    historyAppointments$: Observable<Appointment[]>;

    constructor(private appointmentService: AppointmentService) {
        this.isInit$ = appointmentService.isInit();
        this.historyAppointments$ = appointmentService.getAllAppointmentsObserver().pipe(
            filter(a => a !== null),
            map(appointmentList => appointmentList.filter(a => !this.appointmentService.isUpcomingAppointment(a))),
            map(appointmentList => appointmentList.sort(
                (a, b) => this.appointmentService.compareByAppointmentDate(b, a))
            )
        );
    }
}
